import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import LoginPage from "./LoginPage";
import ProtectedPage from "./ProtectedPage";

function AnimatedRoutes() {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                style={{
                    background: location.pathname === "/" 
                        ? "linear-gradient(135deg, #0f172a, #1e293b)"  // Home Page
                        : "linear-gradient(135deg, #1e293b, #334155)"  // Protected Page
                }}
            >
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/protected" element={<ProtectedPage />} />
                </Routes>
            </motion.div>
        </AnimatePresence>
    );
}

export default function App() {
    return (
        <Router>
            <AnimatedRoutes />
        </Router>
    );
}